$(document).foundation();

var $window = $(window);

jQuery(document).ready(function($) {
  var myElement = document.querySelector("header");
  var headroom  = new Headroom(myElement);
  //headroom.init();

  //navHandler.init();
  searchHandler.init();
  landingHandler.init();
  indexHandler.init();
  pageDetailHandler.init();
  listHandler.init();

  // $('main').css({
  // 	'padding-top': $(myElement).outerHeight() 
  // })

  var lastScrollTop = 0;
  window.addEventListener("scroll", function(){ 
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    var count = 0;
    count = st / 10;
    var topLeft  = (window.outerWidth > 768) ? 25 : 3;
    var topRight = (window.outerWidth > 768) ? 40 : 12;

    if ($('.page-template-page-landing').length > 0) {
      topLeft  = (window.outerWidth > 768) ?  5 : 3;
      topRight = (window.outerWidth > 768) ? 50 : 12;		
    }

    var leftVal  = ((topLeft + count) > 80) ? 80 : topLeft + count;
    var rightVal = ((topRight + count) > 80) ? 80 : topRight + count;

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
